module.exports = require('./$.hide');


/** WEBPACK FOOTER **
 ** ./~/react-native-winjs/~/core-js/library/modules/$.redef.js
 **/